
import { defineComponent } from 'vue'
import LoadingPulse from '@/components/shared/LoadingPulse.vue'

export default defineComponent({
  name: "LockingButton",
  components: {
    LoadingPulse
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    locked: {
      type: Boolean,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  },
  emits: [
    'click'
  ],
  computed: {
    buttonText(): string {
      return this.locked ? '' : this.text
    }
  },
  methods: {
    onButtonClicked(): void {
      this.$emit('click')
    }
  }
});
